"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.experimentsService = exports.ExperimentsService = void 0;
class ExperimentsService {
    isEnabled(experimentName) {
        var _a;
        if (!this.experimentsBag) {
            console.error(`Experiments Service :: isEnabled('${experimentName}') called while experiments are not conducted yet. Returning false`);
            return false;
        }
        const value = (_a = this.experimentsBag) === null || _a === void 0 ? void 0 : _a[experimentName];
        return value === 'true' || value === true || value === 'B';
    }
    init(experimentsBag) {
        this.experimentsBag = Object.assign(Object.assign({}, this.experimentsBag), experimentsBag);
    }
    reset() {
        this.experimentsBag = null;
    }
}
exports.ExperimentsService = ExperimentsService;
exports.experimentsService = new ExperimentsService();
//# sourceMappingURL=index.js.map